let html = `<div class="settings-input">
    <div class="settings-input__content">
        <div class="settings-input__input"></div>

        <div class="simple-keyboard"></div>

        <div class="settings-input__links">#{settings_input_links}</div>
    </div>
</div>`

export default html